import { FormattedMessage } from 'react-intl';
import { IconAdjustments } from '@tabler/icons';

const icons = { IconAdjustments };

const readinessConfig = {
    id: 'readiness-config',
    type: 'group',
    children: [
        {
            id: 'readiness-config-item',
            title: 'Readiness Config',
            type: 'item',
            icon: icons.IconAdjustments,
            url: '/readiness-config'
        }
    ]
};

export default readinessConfig;
